var _path, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVehicleWarning = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#EFF7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1338_38742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9059 33.3484H28.3599C27.1912 33.3484 26.2412 32.2955 26.2412 31.0011V25.7699C26.2412 24.4755 27.1918 23.4226 28.3599 23.4226H30.9059C32.0746 23.4226 33.0246 24.4755 33.0246 25.7699V31.0011C33.0246 32.2955 32.074 33.3484 30.9059 33.3484Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3496 25.8341C28.867 25.8341 29.2891 25.412 29.2891 24.8946C29.2891 24.3772 28.867 23.9551 28.3496 23.9551C27.8323 23.9551 27.4102 24.3772 27.4102 24.8946C27.4102 25.412 27.8323 25.8341 28.3496 25.8341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9516 21.8077C30.98 19.9919 29.1413 16.5519 29.1413 16.5519C28.455 15.2675 27.1764 14.5005 25.7213 14.5005H15.809C14.355 14.5005 13.077 15.2663 12.3901 16.5502C12.075 17.1395 10.2621 20.5326 9.49912 21.9615C8.86597 22.6531 8.50292 23.5744 8.50175 24.5923L8.5 25.7253C8.5 25.7352 8.50117 25.7446 8.50117 25.7545C8.50117 25.7598 8.5 25.7644 8.5 25.7697V31.0009C8.5 32.2953 9.4506 33.3482 10.6187 33.3482H13.1641C14.3328 33.3482 15.2828 32.2953 15.2828 31.0009V29.5908H29.2828C31.3536 29.5908 33.0408 27.8597 33.0437 25.7317L33.0455 24.5397C33.0472 23.4768 32.6409 22.5116 31.9505 21.8071L31.9516 21.8077ZM13.1963 25.8369C12.6789 25.8369 12.2568 25.4148 12.2568 24.8974C12.2568 24.3801 12.6789 23.958 13.1963 23.958C13.7137 23.958 14.1358 24.3801 14.1358 24.8974C14.1358 25.4148 13.7137 25.8369 13.1963 25.8369ZM14.0516 17.4113C14.4182 16.7262 15.0419 16.3491 15.8084 16.3491H25.7207C26.4766 16.3491 27.1168 16.7367 27.4781 17.4125C27.4781 17.4125 28.3778 19.0962 29.1168 20.4789C25.9253 19.6984 21.6184 19.5189 20.7748 19.5189C17.6277 19.5189 14.6362 19.8744 12.4053 20.4911C13.0373 19.3084 13.8224 17.8393 14.051 17.4113H14.0516ZM24.593 25.834H16.9537C16.4351 25.834 16.0142 25.4137 16.0142 24.8945C16.0142 24.3754 16.4345 23.955 16.9537 23.955H24.593C25.1115 23.955 25.5324 24.3754 25.5324 24.8945C25.5324 25.4137 25.1121 25.834 24.593 25.834Z",
    fill: "url(#paint0_linear_1338_38742)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5931 16.9246L39.4242 31.0315C39.6113 31.3683 39.6206 31.7419 39.4213 32.0728C39.2219 32.4037 38.8805 32.5925 38.4835 32.5925H22.8214C22.4239 32.5925 22.083 32.4037 21.8837 32.0728C21.6843 31.7419 21.6937 31.3689 21.8808 31.0315L29.7118 16.9246C29.9001 16.5855 30.2532 16.4001 30.6525 16.4001C31.0518 16.4001 31.4055 16.5861 31.5931 16.9246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4828 33.5224H22.8207C22.1004 33.5224 21.4515 33.16 21.0855 32.5525C20.7166 31.941 20.7096 31.2219 21.0662 30.5794L28.8973 16.4725C29.2457 15.844 29.9017 15.4692 30.6517 15.4692C31.4018 15.4692 32.0572 15.844 32.4062 16.4725L40.2372 30.5794C40.5938 31.2214 40.5868 31.9404 40.2179 32.5525C39.852 33.16 39.203 33.5224 38.4828 33.5224ZM30.6517 17.3307C30.6137 17.3307 30.5465 17.3365 30.5249 17.3763L22.6938 31.4833C22.6558 31.5517 22.6669 31.5704 22.6798 31.592C22.7002 31.6259 22.7295 31.6616 22.8207 31.6616H38.4828C38.574 31.6616 38.6032 31.6259 38.6237 31.592C38.6365 31.5704 38.6476 31.5517 38.6096 31.4833L30.7786 17.3763C30.7558 17.3354 30.6821 17.3307 30.6517 17.3307Z",
    fill: "url(#paint1_linear_1338_38742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6524 26.1943C30.1385 26.1943 29.7217 25.7774 29.7217 25.2635V21.9136C29.7217 21.3997 30.1385 20.9829 30.6524 20.9829C31.1663 20.9829 31.5831 21.3997 31.5831 21.9136V25.2635C31.5831 25.7774 31.1663 26.1943 30.6524 26.1943Z",
    fill: "#D7282F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6524 30.0328C31.1651 30.0328 31.5831 29.6148 31.5831 29.1021C31.5831 28.5894 31.1651 28.1714 30.6524 28.1714C30.1397 28.1714 29.7217 28.5894 29.7217 29.1021C29.7217 29.6148 30.1397 30.0328 30.6524 30.0328Z",
    fill: "#D7282F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1338_38742",
    x1: 8.5,
    y1: 23.9241,
    x2: 33.046,
    y2: 23.9241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1338_38742",
    x1: 22.34,
    y1: 15.379,
    x2: 37.7351,
    y2: 32.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#87B9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDAFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1338_38742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 19.0225,
    fill: "white",
    transform: "translate(8.5 14.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVehicleWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vehicle-warning.dbc33f4c.svg";
export { ForwardRef as ReactComponent };